import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatus } from '@ms/yammer-data-support';

import type { OcpsPolicies, OcpsRequestError } from '../../state/ocps/types';
import type { YammerState } from '../../state/types';

type GetOcpsPolicyDataStatus = (state: YammerState) => EntityStatus;
export const getOcpsPolicyDataStatus: GetOcpsPolicyDataStatus = (state) => getStatus(state.ocps);

type GetOcpsPolicies = (state: YammerState) => OcpsPolicies | undefined;
export const getOcpsPolicies: GetOcpsPolicies = (state) => state.ocps.fulfilled?.policies;

type GetOcpsPolicyCheckInTime = (state: YammerState) => number | undefined;
export const getOcpsPolicyCheckInTime: GetOcpsPolicyCheckInTime = (state) => state.ocps.fulfilled?.checkInTime;
export const getOcpsFailedRequestCheckInTime: GetOcpsPolicyCheckInTime = (state) =>
  (state.ocps.rejected as OcpsRequestError)?.checkInTime;

type GetOcpsPolicyRequestHash = (state: YammerState) => string | undefined;
export const getOcpsPolicyRequestHash: GetOcpsPolicyRequestHash = (state) => state.ocps.fulfilled?.requestHash;

type GetOcpsPolicyCacheVersion = (state: YammerState) => number | undefined;
export const getOcpsPolicyCacheVersion: GetOcpsPolicyCacheVersion = (state) => state.ocps.fulfilled?.cacheVersion;
